import { axiosInstance } from "../axiosInstance";

export const getAdventures = async (searchTerm, startDate, endDate, difficulty, type, isChildFriendly, pageNumber = 1) => {
    const params = new URLSearchParams();

    if (searchTerm) params.append("q", searchTerm);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (difficulty) params.append("difficulty", difficulty);
    if (type) params.append("type", type);
    if (pageNumber) params.append("pageNumber", pageNumber);
    if (typeof isChildFriendly === "boolean") params.append("isChildFriendly", isChildFriendly);
    
    const { data } = await axiosInstance.get(`api/adventures?${params.toString()}`)
    return data;
}


export const getAdventuresOptions = async () => {
  try {
    const { data } = await axiosInstance.get(`api/adventures/options`);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getAdventure = async (adventureId) => { 
    const { data } = await axiosInstance.get(`api/adventures/${adventureId}`)
    return data;
}

export const getUpcomingAdventure = async () => {
    const { data } = await axiosInstance.get(`api/adventures/upcoming`)
    return data;
}

export const AddAdventure = async ( adventure ) => {
    try 
    {
        const { data } = await axiosInstance.post(`api/adventures`, adventure)
        return data;
    }
    catch(error)
    {
        throw error;
    }
}

export const UpdateAdventure = async (adventure) => {
  try {
    const { adventureId, ...newAdventure } = adventure;
    console.log(newAdventure);
    const { data } = await axiosInstance.put(
      `api/adventure/${adventureId}`,
      newAdventure
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const DeleteAdventure = async (adventure) => {
  try {
    const { data } = await axiosInstance.delete(
      `api/adventures/${adventure.adventureId}`
    );
    console.log(data);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getAdventureImage = async (adventureId, isDisplayImage) => {
    const params = new URLSearchParams();
    if (typeof isDisplayImage === "boolean") params.append("isDisplayImage", isDisplayImage);
    
    const { data } = await axiosInstance.get(`api/adventures/${adventureId}/images?${params.toString()}`)
    return data;
}